// src/pages/FeaturesPage.tsx
import React from 'react';

const FeaturesPage = () => {
const features = [
    {
      title: 'Carrier Document Collection',
      description: 'Collect and manage all required carrier compliance documents in one place.',
      icon: 'document',
      bullets: [
        'COI, W9, MC/DOT Authority',
        'Insurance endorsements',
        'Voided checks for ACH setup'
      ]
    },
    {
      title: 'Compliance Tracking',
      description: 'Track document status and insurance expirations with real-time alerts.',
      icon: 'verify',
      bullets: [
        'Approve/reject with notes',
        'Insurance expiration warnings',
        'Full audit trail',
        'Compliance status dashboard'
      ]
    },
    {
      title: 'Carrier Onboarding Flow',
      description: 'Guided 6-step onboarding for carriers with digital signature.',
      icon: 'workflow',
      bullets: [
        'Company & contact info',
        'Insurance verification',
        'Payment setup',
        'Digital agreement signing'
      ]
    },
    {
      title: 'Broker Code System',
      description: 'Unique broker codes let carriers send applications to multiple brokers.',
      icon: 'key',
      bullets: [
        'One carrier profile, multiple brokers',
        'Shared document uploads',
        'Independent approval per broker'
      ]
    },
    {
      title: 'Document Requests',
      description: 'Request additional documents from carriers anytime.',
      icon: 'request',
      bullets: [
        'Request specific document types',
        'Carrier notifications',
        'Track fulfillment status'
      ]
    },
    {
      title: 'Carrier Management',
      description: 'Approve or reject carriers at the carrier level, not just documents.',
      icon: 'manage',
      bullets: [
        'Carrier-level approval',
        'Compliance progress bars',
        'Quick status overview'
      ]
    }
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 py-16">
      <div className="text-center mb-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">Our Features</h1>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          Everything you need to streamline employee onboarding and document verification
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {features.map((feature, index) => (
          <div key={index} className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition">
            {/* Feature Card Header */}
            <div className="mb-4">
              <div className="text-4xl mb-3">
                {feature.icon === 'document' && '📄'}
                {feature.icon === 'verify' && '✅'}
                {feature.icon === 'workflow' && '🔄'}
                {feature.icon === 'key' && '🔑'}
                {feature.icon === 'request' && '📨'}
                {feature.icon === 'manage' && '👥'}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-gray-600 text-sm">{feature.description}</p>
            </div>

            {/* Bullet Points */}
            <ul className="space-y-2">
            {feature.bullets.map((bullet, i) => (
                  <li key={i} className="flex items-start text-sm text-gray-700">
                    <span className="text-green-500 mr-2">✓</span>
                    <span>{bullet}</span>
                  </li>
                ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Call to Action */}
      <div className="mt-20 text-center bg-blue-50 rounded-2xl p-12">
        <h2 className="text-3xl font-bold text-gray-900 mb-4">
          Ready to streamline your onboarding?
        </h2>
        <p className="text-xl text-gray-600 mb-8">
          Join companies saving time with LoadDrive's document verification platform
        </p>
        <div className="flex gap-4 justify-center">
          <a
            href="/register"
            className="px-8 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-semibold transition"
          >
            Start Free Trial
          </a>
          <a
            href="/pricing"
            className="px-8 py-3 bg-white text-blue-600 border-2 border-blue-600 rounded-lg hover:bg-blue-50 font-semibold transition"
          >
            View Pricing
          </a>
        </div>
      </div>
    </div>
  );
};

export default FeaturesPage;
